// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:08:46

export default {
  "id": "royal-kitchen-the-lost-king",
  "slug": "royal-kitchen-the-lost-king",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0db63a459f8e499c9c5526d78d11da47-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0db63a459f8e499c9c5526d78d11da47/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Royal Kitchen: The Lost King",
      "description": "In a lost kingdom, disaster has struck! During a knight’s tournament, a mysterious figure in a black cloak suddenly appears. The stranger casts a spell on the king, causing him to vanish without a trace right before everyone’s eyes!\n\nThe princess manages to escape from the castle, but where should she go now? How can she save her father and the entire kingdom? Will she be able to overcome all the challenges, find her father, and defeat the evil wizard?",
      "instructions": "The controls are quite simple: click on objects highlighted in green, gather resources, clear obstacles with them, and accomplish your objectives.\n\nDevelop your strategy at the start of each level and achieve your goal! Every second counts!",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2d"
      ]
    },
    "zh-CN": {
      "title": "皇家厨房：失踪的国王",
      "description": "在一个失落王国，灾难降临！在一次骑士锦标赛上，一个身穿黑色斗篷的神秘人物突然出现。陌生人对一个咒语在国王身上，导致他在众目睽睽之下消失得无影无踪！\n\n公主设法逃离了城堡，但她现在该去哪里呢？她如何拯救她的父亲和整个王国？她能否克服所有挑战，找到她的父亲，并击败邪恶的巫师？",
      "instructions": "控制非常简单：点击绿色高亮的物体，收集资源，用它们清除障碍，完成目标。\n\n在每关开始时制定你的策略，实现你的目标！每一秒都很重要！",
      "genres": [
        "冒险"
      ],
      "tags": [
        "二维"
      ]
    },
    "zh-TW": {
      "title": "皇家廚房：失落的國王",
      "description": "在一個失落王國中，災禍降臨！在一名騎士比武大會上，一個神秘的黑衣人突然出現。那個陌生人對國王施展了咒語，讓他在眾人眼前無蹤無影地消失！\n\n公主成功逃離了城堡，但現在該去哪裡呢？她該如何拯救她的父親和整個王國？她能否克服所有挑戰，找到她的父親，並擊敗邪惡的巫師？",
      "instructions": "控制方式相當簡單：點擊綠色突出顯示的物體，收集資源，用它們清除障礙，並完成你的目標。\n\n在每個關卡開始時制定你的策略，並達成你的目標！每一秒都計數！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D"
      ]
    },
    "zh-HK": {
      "title": "皇家廚房：失落之王",
      "description": "在一個失落王國，災禍降臨！在一位騎士比武大會中，一個神秘的黑衣人突然出現。那個陌生人對國王施展了咒語，讓他在眾人眼前消失無蹤！\n\n公主成功逃離城堡，但現在該去哪裡呢？她如何拯救父親和整個王國？她能否克服所有挑戰，找到父親，並擊敗邪惡的巫師？",
      "instructions": "控制相當簡單：點擊被綠色高亮標記的物體，收集資源，用它們清除障礙，並完成目標。\n\n每個關卡開始時制定策略，達成目標！每一秒都計數！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "二維"
      ]
    },
    "ja": {
      "title": "ロイヤルキッチン：失われた王",
      "description": "失われた王国で災害が襲った！騎士の試合中に、黒いコートを着た謎の人物が突然現れた。その陌生人は国王に魔法をかけ、その場で姿を消した！\n\nプリンセスは城から逃げ出したが、今や彼女はどこに行けばいいのか？父親と王国を救う方法はあるのか？彼女は全ての挑戦を乗り越え、父親を見つけ、邪悪な魔法使いを倒せるのか？",
      "instructions": "コントロールは非常に簡単です：緑色でハイライトされたオブジェクトをクリックし、リソースを集め、それを使って障害物を取り除き、目標を達成してください。\n\n各レベルの開始時に戦略を展開し、目標を達成しましょう！一秒間も大切です！",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2D"
      ]
    },
    "ko": {
      "title": "로얄 키친: 잃어버린 왕",
      "description": "빛바랗는 왕국에서 재앙이 휩쓸고过去了!騎士 대회 중에 검은 옷을 입은 미스터리한 인물이 갑자기 나타났습니다. 그陌生人에게 마법을 걸려 왕이 눈앞에서 사라졌습니다!\n\n공주는 성에서 탈출에 성공했지만 지금 어디로 가야 할까요? 그녀는 아버지와 왕국을 구할 수 있을까요? 모든 도전을 극복하고 아버지를 찾아내고 악한 마법사를 꺼낼 수 있을까요?",
      "instructions": "제어方法是 매우 간단합니다:緑색으로 밝혀진 대상을 클릭하고 자원을 수집하여 장애물을 제거하고 목표를 달성하세요! 각 레벨 시작 시 전략을 개발하고 목표를 달성하세요! 모든 초가 중요합니다!",
      "genres": [
        "모험"
      ],
      "tags": [
        "2D"
      ]
    },
    "fr": {
      "title": "Royal Kitchen : Le Roi Perdu",
      "description": "Dans un royaume perdu, la désolation s'est abattue ! Pendant un tournoi de chevaliers, une figure mystérieuse vêtue d'un manteau noir s'approche soudain. L'inconnu lance un sort sur le roi, qui disparaît sans laissé la moindre trace sous les yeux de tous !\n\nLa princesse parvient à s'échapper du château, mais où doit-elle aller maintenant ? Comment peut-elle sauver son père et tout le royaume ? Serait-elle capable de surmonter tous les défis, retrouver son père et vaincre le sorcier maléfique ?",
      "instructions": "Les commandes sont assez simples : cliquez sur les objets mis en valeur en vert, rassemblez des ressources, éliminez les obstacles avec elles et accomplissez vos objectifs.\n\nDéveloppez votre stratégie au début de chaque niveau et atteignez votre objectif ! Chaque seconde compte !",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2D"
      ]
    }
  }
};
